export default __webpack_public_path__ + "static/media/savego.35bb7e90.png";